/** Strings of the UI kit (`src/ui`). Owner: UI/Visual. Keys are full (`ui.*`); values are ICU-lite templates (src/shared/i18n.ts). */
export const ui = {
  'ui.stub.lead': 'Писец ещё переписывает эту главу: чернила не высохли, позолота не легла.',
  'ui.stub.soon': 'Страница появится в первой редакции рукописи.',
  'ui.stub.later': 'Эта страница — для следующих редакций рукописи.',
  'ui.tab.life': 'Житие',
  'ui.tab.road': 'Странствия',
  'ui.tab.arena': 'Ристалище',
  'ui.tab.cards': 'Таверна',
  'ui.tab.order': 'Орден',
  'ui.tab.short.life': 'Житие', 'ui.tab.short.road': 'Путь', 'ui.tab.short.arena': 'Бой', 'ui.tab.short.cards': 'Карты', 'ui.tab.short.order': 'Орден',
  'ui.nav.label': 'Главы рукописи',

  // ── kit ──
  'ui.kit.close': 'Закрыть',
  'ui.kit.back': 'Назад',
  'ui.kit.cancel': 'Отмена',
  'ui.kit.more': 'Ещё',
  'ui.kit.info': 'Пояснение',
  'ui.kit.typeToConfirm': 'Впишите слово «{word}», чтобы подтвердить',
  'ui.coach.tapAnywhere': 'Коснитесь где угодно, чтобы продолжить',
  'ui.tab.locked.level': 'Откроется на {level}-м уровне',
  'ui.tab.locked.day': 'Откроется с Новым днём',

  // ── Настройки (ui-ux §6.24) ──
  'ui.settings.title': 'Настройки',
  'ui.settings.language': 'Язык / Language',
  'ui.settings.language.hint': 'Прогресс сохранится, книга откроется на выбранном языке.',
  'ui.settings.sections': 'Разделы настроек',
  'ui.settings.sec.text': 'Текст',
  'ui.settings.sec.image': 'Изображение',
  'ui.settings.sec.sound': 'Звук',
  'ui.settings.sec.fight': 'Поединок',
  'ui.settings.sec.controls': 'Управление',
  'ui.settings.sec.road': 'Странствия',
  'ui.settings.sec.cards': 'Карты',
  'ui.settings.sec.data': 'Данные',
  'ui.settings.sec.keys': 'Клавиши',
  'ui.settings.sec.about': 'Об игре',
  'ui.settings.size': 'Размер текста',
  'ui.settings.font': 'Шрифт',
  'ui.settings.font.calligraphic': 'Рукописный',
  'ui.settings.font.plain': 'Простой',
  'ui.settings.preview': 'Пушок нашёл сапог. Один.',
  'ui.settings.theme': 'Тема',
  'ui.settings.theme.system': 'Как в системе',
  'ui.settings.theme.day': 'Светлая',
  'ui.settings.theme.night': 'Ночная',
  'ui.settings.theme.hint': 'Ночной список появится в следующей редакции.',
  'ui.settings.lite': 'Упрощённая графика',
  'ui.settings.lite.hint': 'Рисованные боевые сцены вместо объёмных. Все приключения доступны.',
  'ui.settings.lite.locked': 'На этом устройстве включены рисованные боевые сцены.',
  'ui.settings.quality': 'Качество',
  'ui.settings.quality.hint': 'Книга откроется заново с выбранным качеством. Прогресс сохранится.',
  'ui.settings.quality.auto': 'Авто',
  'ui.settings.quality.low': 'Низкое',
  'ui.settings.quality.med': 'Среднее',
  'ui.settings.quality.high': 'Высокое',
  'ui.settings.quality.ultra': 'Наивысшее',
  'ui.settings.fps': 'Кадров в секунду',
  'ui.settings.motion': 'Меньше движения',
  'ui.settings.motion.full': 'Нет',
  'ui.settings.motion.reduced': 'Сдержанно',
  'ui.settings.motion.min': 'Минимум',
  'ui.settings.shake': 'Тряска',
  'ui.settings.flash': 'Вспышки',
  'ui.settings.highContrast': 'Высокий контраст',
  'ui.settings.shortCinematics': 'Короткие ролики',
  'ui.settings.fullscreen': 'Во весь экран',
  'ui.settings.master': 'Общая громкость',
  'ui.settings.music': 'Музыка',
  'ui.settings.sfx': 'Эффекты',
  'ui.settings.mute': 'Без звука',
  'ui.settings.cues': 'Звуковые подсказки',
  'ui.settings.vibration': 'Вибрация',
  'ui.settings.battleSpeed': 'Скорость поединка',
  'ui.settings.noRush': 'Без спешки',
  'ui.settings.noRush.hint': 'Никто не решает за вас, пока окно открыто.',
  'ui.settings.omensAuto': 'Знамения: авто',
  'ui.settings.numbers': 'Числа урона',
  'ui.settings.leftHanded': 'Левша',
  'ui.settings.leftHanded.hint': 'Главная кнопка и молитвы — под левый большой палец.',
  'ui.settings.confirmSpend': 'Подтверждать траты от',
  'ui.settings.confirmSpend.gold': '{n} зол.',
  'ui.settings.confirmSpend.always': 'всегда',
  'ui.settings.confirmSpend.never': 'никогда',
  'ui.settings.cardsFastAnim': 'Быстрые анимации',
  'ui.settings.cardsHints': 'Подсказки в первых партиях',
  'ui.settings.notify': 'Уведомления',
  'ui.settings.notify.hint': 'Только с вашего согласия.',
  'ui.settings.install': 'Установить на экран',
  'ui.settings.exportSave': 'Сохранить копию',
  'ui.settings.importSave': 'Загрузить копию',
  'ui.settings.diagnostics': 'Скопировать диагностику',
  'ui.settings.reset': 'Сбросить прогресс',
  'ui.settings.reset.title': 'Сбросить прогресс?',
  'ui.settings.reset.consequence': 'Летопись, герой и всё добро исчезнут. Вернуть их будет нельзя.',
  'ui.settings.reset.word': 'СБРОС',
  'ui.settings.reset.verb': 'Сбросить',
  'ui.settings.unavailable': 'Это действие появится вместе с хранилищем рукописи.',
  'ui.settings.notSaved': 'Настройка действует до перезапуска: записать её не вышло.',
  'ui.settings.keys.everywhere': 'Везде: 1–5 вкладки · Esc закрыть или назад · ? шпаргалка · M звук',
  'ui.settings.keys.life': 'Житие: кнопки путей ведут в поединок, странствие и таверну.',
  'ui.settings.keys.fight': 'Поединок: выбери тактику и нажми на молитву, когда хватит пыла.',
  'ui.settings.keys.road': 'Странствия: выбирай ответ на встрече, заглядывай в кодекс и склеп.',
  'ui.settings.keys.make': 'Облик: выбери зверя, измени его внешность и впиши в летопись.',
  'ui.settings.keys.cards': 'Карты: выбирай карту и ряд или пасуй, сохраняя карты для следующего раунда.',
  'ui.settings.about.lead': 'Маргиналии — поля огромного кодекса, где ожили звери-заступники.',
  'ui.settings.about.version': 'Редакция {version}',
  'ui.settings.about.fonts': 'Шрифты Alegreya, Alegreya SC, Alegreya Sans и Ruslan Display — по лицензии SIL Open Font License.',
  'ui.settings.saved': 'Записано на полях',

  // ── «Книга образцов» (the kit showcase, ?screen=uikit) ──
  'ui.kit.title': 'Книга образцов',
  'ui.kit.lead': 'Всё, чем пишется рукопись: кнопки, плитки, ленты, листы и печати — на одной странице.',
  'ui.kit.sec.buttons': 'Кнопки',
  'ui.kit.sec.tiles': 'Плитки молитв и глаголов',
  'ui.kit.sec.chrome': 'Вкладки и полоса добра',
  'ui.kit.sec.surfaces': 'Поверхности',
  'ui.kit.sec.bars': 'Ленты здоровья и полосы',
  'ui.kit.sec.forms': 'Линейки и печати',
  'ui.kit.sec.overlays': 'Листы, окна и вести',
  'ui.kit.sec.text': 'Буквицы и свитки',
  'ui.kit.sec.glyphs': 'Знаки оболочки',
  'ui.kit.sec.layout': 'Разметка поединка',
  'ui.kit.btn.fight': 'В бой!',
  'ui.kit.btn.claim': 'Забрать',
  'ui.kit.btn.details': 'Подробнее',
  'ui.kit.btn.sell': 'Сбыть',
  'ui.kit.btn.later': 'Решить позже',
  'ui.kit.btn.locked': 'Нужно 30 Благодати',
  'ui.kit.btn.main': 'Главное: в бой',
  'ui.kit.btn.mainSub': 'Агриппина ждёт на ристалище',
  'ui.kit.btn.pause': 'Пауза',
  'ui.kit.btn.skip': 'К развязке',
  'ui.kit.hold': 'Удерживай, чтобы пропустить',
  'ui.kit.prayer.ward': 'Заступ.',
  'ui.kit.prayer.wardFull': 'Молитва: Заступничество, {cost} пыла',
  'ui.kit.prayer.heal': 'Исцел.',
  'ui.kit.prayer.healFull': 'Молитва: Исцеление, {cost} пыла',
  'ui.kit.prayer.wrath': 'Гнев',
  'ui.kit.prayer.wrathFull': 'Молитва: Праведный гнев, {cost} пыла',
  'ui.kit.prayer.pear': 'Груша',
  'ui.kit.prayer.pearFull': 'Молитва: Груша с небес, {cost} пыла',
  'ui.kit.verb.bless': 'Благословить',
  'ui.kit.verb.smite': 'Покарать',
  'ui.kit.verb.blessFull': 'Благословить за {cost} Благодати',
  'ui.kit.verb.smiteFull': 'Покарать за {cost} Благодати',
  'ui.kit.verb.timer': '6 мин',
  'ui.kit.state.ready': 'готова',
  'ui.kit.state.short': 'не хватает',
  'ui.kit.state.queued': 'в очереди',
  'ui.kit.state.used': 'потрачена',
  'ui.kit.state.vow': 'обет',
  'ui.kit.state.react': 'окно ответа',
  'ui.kit.chip.gold': 'Золото: {n}',
  'ui.kit.chip.grace': 'Благодать: {n}',
  'ui.kit.chip.candles': 'Свечи: {n} из 6',
  'ui.kit.chip.keys': 'Ключи: {n}',
  'ui.kit.seg.stats': 'Стати',
  'ui.kit.seg.gear': 'Снаряжение',
  'ui.kit.seg.chronicle': 'Летопись',
  'ui.kit.seg.more': 'Ещё',
  'ui.kit.filter.all': 'Все',
  'ui.kit.filter.weapons': 'Оружие',
  'ui.kit.filter.relics': 'Мощи',
  'ui.kit.panel.now': 'Сейчас',
  'ui.kit.panel.nowBody': 'Пушок бредёт к Чернильному городку. Ноги сбиты, дух бодр, кошель лёгок.',
  'ui.kit.panel.plain': 'Сундук',
  'ui.kit.panel.plainRow1': 'Скалка дубовая',
  'ui.kit.panel.plainRow2': 'Псалтирь с медными застёжками',
  'ui.kit.panel.plainRow3': 'Капюшон послушника',
  'ui.kit.plate.title': 'Агриппина Гусыня',
  'ui.kit.plate.caption': 'Ур. 8 · ставка ×1,25 · шансы равные',
  'ui.kit.band': 'Часы дня',
  'ui.kit.banderole': 'Сэр Мурзик Косоглазый',
  'ui.kit.banderoleSub': 'кот-крестоносец, 8-й уровень',
  'ui.kit.card.title': 'Склеп «Чернильный подвал»',
  'ui.kit.card.caption': 'Ключ · 12 комнат · лучина 18',
  'ui.kit.card.locked': 'Орден',
  'ui.kit.card.lockedCaption': 'Откроется на 8-м уровне',
  'ui.kit.ribbon.player': 'Здоровье: Сэр Мурзик',
  'ui.kit.ribbon.foe': 'Здоровье: Агриппина',
  'ui.kit.ribbon.hit': 'Удар',
  'ui.kit.ribbon.heal': 'Лечение',
  'ui.kit.xp': 'Опыт до следующего уровня',
  'ui.kit.fervor': 'Пыл',
  'ui.kit.fervorLabel': 'Пыл: {n} из 100',
  'ui.kit.candles': 'Свечи: 4 из 6',
  'ui.kit.ruler': 'Длина ушей',
  'ui.kit.toggle': 'Звуковые подсказки',
  'ui.kit.name': 'Имя героя',
  'ui.kit.namePlaceholder': 'Мурзик',
  'ui.kit.sheet.open': 'Открыть лист',
  'ui.kit.sheet.title': 'Наставление',
  'ui.kit.sheet.body': 'Агриппина бьёт крылом с размаху. Держите Заступничество наготове и не спешите с Гневом.',
  'ui.kit.modal.open': 'Открыть окно',
  'ui.kit.modal.title': 'Пауза',
  'ui.kit.modal.body': 'Поединок замер. Писец ждёт, пока вы решитесь.',
  'ui.kit.modal.resume': 'Продолжить',
  'ui.kit.modal.quit': 'Сдаться',
  'ui.kit.confirm.open': 'Сбыть вещь',
  'ui.kit.confirm.title': 'Сбыть Псалтирь?',
  'ui.kit.confirm.body': 'Купец даст 120 золотых. Выкупить вещь назад будет нельзя.',
  'ui.kit.toast.open': 'Послать весть',
  'ui.kit.toast.text': 'Открыто: Таверна',
  'ui.kit.toast.error': 'Перо сломалось: запись не удалась',
  'ui.kit.tip.open': 'Подсказка',
  'ui.kit.tip.title': 'Благодать',
  'ui.kit.tip.text': 'Копится, пока герой странствует. Тратится на глаголы Покровителя.',
  'ui.kit.coach.open': 'Наставник',
  'ui.kit.coach.text': 'Молитва стоит пыла. Коснитесь плитки, когда печать загорится.',
  'ui.kit.dropcap': 'В лето тысяча триста тридцать третье кот Мурзик, рыцарь без страха и почти без упрёка, вышел из ворот обители и направил стопы к Чернильному городку, где, по слухам, гуси бесчинствовали пуще прежнего.',
  'ui.kit.scroll': 'Получай, пернатая!',
  'ui.kit.scrollReply': 'Га-га. Посмотрим.',
  'ui.kit.dmg': 'Числа урона',
  'ui.kit.layout.hint': 'Прямоугольники fightLayout() для выбранного экрана: панель, поля, знамение, ряд молитв.',
  'ui.kit.layout.viewport': 'Экран',
  'ui.kit.gifts': 'Даёт: опыт, добро, Стойкость',
  'ui.kit.swatches': 'Палитры шерсти',
  'ui.kit.roundels': 'Уши',
} as const;
